module.exports = __webpack_public_path__ + "src/assets/img/uralmash.0a64941b.jpg";